import React from 'react';

const SrPartnerApprovalContext = React.createContext();
SrPartnerApprovalContext.displayName = 'SrPartnerApprovalContext';

export default SrPartnerApprovalContext;
